// src/pages/interviewProcesses/BusinessDevelopmentManagerInterview.js
import React from 'react';
import '../HumanResources.css';

function BusinessDevelopmentManagerInterview() {
  return (
    <div className="hr-page">
      <h1>Interview Process for Business Development Manager</h1>
      <p>
        This process evaluates the candidate's experience in business development strategies, sales and negotiation skills, relationship building, market analysis, and performance measurement.
      </p>

      <h2>Stage 1: Application Screening</h2>
      <p><strong>Purpose:</strong> A brief conversation to assess basic qualifications and initial interest.</p>
      <h3>Questions:</h3>
      <ul>
        <li>Experience in business development (industries, deal sizes, territories).</li>
        <li>Salary expectations and notice period.</li>
        <li>General overview of career path and motivations.</li>
      </ul>

      <h2>Stage 2: First Round Interview (HR/Recruiter)</h2>
      <p><strong>Purpose:</strong> A more in-depth discussion to assess skills and qualifications, often including behavioral questions.</p>
      <h3>Questions:</h3>
      <ul>
        <li>Describe a successful business development strategy you designed and executed.</li>
        <li>What sales techniques have you found most effective in closing deals?</li>
        <li>Tell me about a time you handled a tough objection from a potential client. How did you overcome it?</li>
      </ul>

      <h2>Stage 3: Second Round Interview (Hiring Manager/Team Lead)</h2>
      <p><strong>Purpose:</strong> A technical and role-specific interview to assess suitability for the position and company culture.</p>
      <h3>Topics & Questions:</h3>
      <ul>
        <li><strong>Understanding of Products/Services:</strong> How would you pitch our core offerings to a new market?</li>
        <li><strong>Market Analysis:</strong> How do you conduct market research, identify trends, and analyze the competitive landscape?</li>
        <li><strong>Opportunity Prioritization:</strong> How do you identify new opportunities, prioritize them, and develop strategies to pursue them?</li>
        <li><strong>Sales & Negotiation:</strong> How do you approach negotiations, handle objections, and close deals?</li>
        <li><strong>Relationship Building:</strong> How do you build and maintain strong relationships with clients and partners?</li>
        <li><strong>Performance Metrics:</strong> How do you measure the success of your business development efforts and use data to inform future strategies?</li>
      </ul>

      <h2>Stage 4: Final Round (Board of Directors)</h2>
      <p><strong>Purpose:</strong> To determine long-term fit and discuss compensation and benefits.</p>
      <h3>Questions:</h3>
      <ul>
        <li>What are your long-term goals and how do they align with our company's vision?</li>
        <li>Describe your leadership style. How do you delegate and motivate a team?</li>
        <li>How would you collaborate with internal teams (marketing, product, finance) to achieve business development goals?</li>
        <li>What contributions do you envision making in your first 6–12 months?</li>
      </ul>
    </div>
  );
}

export default BusinessDevelopmentManagerInterview;
